module.exports = __webpack_public_path__ + "img/escola_creative_learning_cookingclass.1b45cbaf.jpeg";